import { InputText } from "./types/_FormInputs";
import { InputMedia } from "./types/_FormMedia";
import { InputSlide } from "./types/_FormSlide";
import { InputHtml } from "./types/_FormHtml";
import { InputColor } from "./types/_FormColor";
import { InputSelect } from "./types/_FormSelect";
import { InputManualStats } from "./types/_FormManualStats";
import { InputMultiple } from "./types/_FormMultiple";
import { InputMultipleSelect } from "./types/_FormMultipleSelect";
import { InputCheckboxGroup } from "./types/_FormCheckboxGroup";
import { InputCheckboxSingle } from "./types/_FormSingleCheckbox";

import { InputMultipleText } from "./types/_FormMultipleText";

export default (props) => {
  const { fields, form, feedType, onValuesChange } = props;
  const entries = [];

  fields.map((item, index) => {
    if (item.type === "text") {
      entries.push(
        <InputText key={item.id + index} item={item} index={index} style={item.style} />,
      );
    } else if (item.type === "media") {
      entries.push(
        <InputMedia key={item.id + index} item={item} index={index} />,
      );
    } else if (item.type === "slide") {
      entries.push(
        <InputSlide
          key={item.id + index}
          item={item}
          index={index}
          feedType={feedType}
        />,
      );
    } else if (item.type === "select") {
      if (item.id === "facts_country") {
        if (feedType === "heimspiel") {
          entries.push(
            <InputSelect
              key={item.id + index}
              item={item}
              index={index}
              feedType={feedType}
              onValuesChange={onValuesChange}
            />,
          );
        }
      } else {
        entries.push(
          <InputSelect key={item.id + index} item={item} index={index} />,
        );
      }
    } else if (item.type === "html") {
      entries.push(
        <InputHtml key={item.id + index} item={item} index={index} />,
      );
    } else if (item.type === "color") {
      entries.push(
        <InputColor key={item.id + index} item={item} index={index} />,
      );
    } else if (item.type === "manual-stats") {
      entries.push(
        <InputManualStats key={item.id + index} item={item} index={index} />,
      );
    } else if (item.type === "multiple-select") {
      entries.push(
        <InputMultipleSelect key={item.id + index} item={item} index={index} form={form} />,
      );
    } else if (item.type === "multiple") {
      entries.push(
        <InputMultiple key={item.id + index} item={item} index={index} />,
      );
    } else if (item.type === "checkbox-group") {
      entries.push(
        <InputCheckboxGroup key={item.id + index} item={item} index={index} form={form} />,
      );
    } else if (item.type === "checkbox-single") {
      entries.push(
        <InputCheckboxSingle key={item.id + index} item={item} index={index} form={form} />,
      );
    } else if (item.type === "multiple-input") {
      entries.push(
        <InputMultipleText key={item.id + index} item={item} index={index} form={form} />,
      );
    } else {
      <br />;
      entries.push(
        <div key={"Not_supported_" + index}>Form type not supported</div>,
      );
    }
  });

  return <>{entries}</>;
};
